import { useLocation } from 'react-router'
import { useCallback, useContext, useEffect, useState } from "react";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ButtonBars from "../components/ButtonBars";
import { FilterHistory } from "../components/FilterHistory";
import useAxiosRequests from "../hooks/useAxiosRequest";
import AuthContext from "../context/AuthContext";
import ExternalRoutes from "../config/ExternalRoutes";
import { DocumentList } from "../components/DocumentList";
import { CircularProgress } from "@mui/material";

export const DocumentHistory = () => {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const { userInfo } = useContext(AuthContext);
  const { sendRequest } = useAxiosRequests();
  const [historys, setHistorys] = useState([]);
  const [loading, setLoading] = useState(true);
  const { state } = useLocation();
  const { startDate, endDate, docType, status } = state || {};
  console.log(startDate);

  const formatDateForApi = (date, isEnd = false) => {
    if (!date) return undefined;
    const d = (date instanceof Date) ? date : new Date(date);

    // Décalage UTC → local
    const localDate = new Date(d.getTime() - (d.getTimezoneOffset() * 60000));

    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, '0');
    const day = String(localDate.getDate()).padStart(2, '0');

    // Ajoute heure début ou fin
    const time = isEnd ? 'T23:59:59' : 'T00:00:00';

    return `${year}-${month}-${day}${time}`;
  };



  const safeStartDate = startDate instanceof Date ? startDate.toISOString() : null
  const safeEndDate = endDate instanceof Date ? endDate.toISOString() : null
  const fetchData = useCallback(async () => {
    try {
      const response = await sendRequest({
        method: "GET",
        url: ExternalRoutes.history.list + userInfo.id,
        config: {
          params: {
            'dcmtStDate[after]':startDate,
            'dcmtStDate[before]':endDate,
            'conDocument.docType': docType,
          }
        }
      });

      if (response) {
        setHistorys(response.member);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, [sendRequest, userInfo.id, safeStartDate, safeEndDate, docType, status]);


  useEffect(() => {
    setLoading(true);
    fetchData();
  }, [startDate, endDate, docType, status])

  return (
    <>
      <header className="kl-header-document-document">
        <div className="kl-admin-header">
          <button
            onClick={() => window.history.back()}
            className="p-0 kl-back-button"
          >
            <FontAwesomeIcon icon={faArrowLeft} className="kl-icon-arrow" />
          </button>
          <div className="kl-logo-contab">
            <span>Historique</span>
          </div>
          <button className="kl-button-filter-document" onClick={handleShow}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.9298 22.75C10.4498 22.75 9.96985 22.63 9.52985 22.39C8.63985 21.89 8.1098 21 8.1098 19.99V14.64C8.1098 14.13 7.77979 13.38 7.46979 12.99L3.6698 9.00003C3.0398 8.37003 2.5498 7.27002 2.5498 6.46002V4.14005C2.5498 2.53005 3.76982 1.27002 5.31982 1.27002H18.6598C20.1898 1.27002 21.4298 2.51004 21.4298 4.04004V6.26004C21.4298 7.31004 20.7998 8.52002 20.1998 9.11002C19.9098 9.40002 19.4298 9.40002 19.1398 9.11002C18.8498 8.82002 18.8498 8.34002 19.1398 8.05002C19.5098 7.68002 19.9298 6.85004 19.9298 6.26004V4.04004C19.9298 3.34004 19.3598 2.77002 18.6598 2.77002H5.31982C4.60982 2.77002 4.0498 3.37005 4.0498 4.14005V6.46002C4.0498 6.83002 4.34981 7.56004 4.73981 7.95004L8.58984 12C9.09984 12.63 9.59979 13.69 9.59979 14.64V19.99C9.59979 20.65 10.0498 20.97 10.2498 21.08C10.6798 21.32 11.1898 21.31 11.5898 21.07L12.9898 20.17C13.2798 20 13.5598 19.45 13.5598 19.08C13.5598 18.67 13.8998 18.33 14.3098 18.33C14.7198 18.33 15.0598 18.67 15.0598 19.08C15.0598 19.98 14.4998 21.01 13.7898 21.44L12.3998 22.34C11.9498 22.61 11.4398 22.75 10.9298 22.75Z" fill="#292D32" />
              <path d="M16.0701 17.2701C13.8901 17.2701 12.1201 15.5001 12.1201 13.3201C12.1201 11.1401 13.8901 9.37012 16.0701 9.37012C18.2501 9.37012 20.0201 11.1401 20.0201 13.3201C20.0201 15.5001 18.2501 17.2701 16.0701 17.2701ZM16.0701 10.8701C14.7201 10.8701 13.6201 11.9701 13.6201 13.3201C13.6201 14.6701 14.7201 15.7701 16.0701 15.7701C17.4201 15.7701 18.5201 14.6701 18.5201 13.3201C18.5201 11.9701 17.4201 10.8701 16.0701 10.8701Z" fill="#292D32" />
              <path d="M19.8705 17.8701C19.6805 17.8701 19.4905 17.8001 19.3405 17.6501L18.3405 16.6501C18.0505 16.3601 18.0505 15.8801 18.3405 15.5901C18.6305 15.3001 19.1105 15.3001 19.4005 15.5901L20.4005 16.5901C20.6905 16.8801 20.6905 17.3601 20.4005 17.6501C20.2605 17.7901 20.0605 17.8701 19.8705 17.8701Z" fill="#292D32" />
            </svg>
          </button>
        </div>
      </header>
      <section>
        {loading ? (
          <div className='kl-nothing-data'>
            <CircularProgress />
          </div>
        ) : (
          <>
            {historys.length > 0 ? (
              <div className="kl-history-list">
                {historys.map((history, key) => {
                  return <DocumentList key={key} document={history?.conDocument} type={history?.status} story={history} />
                })}
              </div>
            ) : (
              <div className='kl-nothing-data'>
                Aucun document trouvé.
              </div>
            )}
          </>
        )}
      </section>
      <ButtonBars />
      <FilterHistory show={show} onClose={() => setShow(false)} />
    </>
  );
};
